var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 57C21 28.8335 43.8335 6 72 6H302C330.167 6 353 28.8335 353 57V273C353 301.167 330.167 324 302 324H72C43.8335 324 21 301.167 21 273V57Z",
    fill: "#FFD382",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPattern);
export default __webpack_public_path__ + "static/media/yellow-pattern.c6e870c3be9b7915139b87c411cbcd1c.svg";
export { ForwardRef as ReactComponent };